<script>
export default {
  props: {
    pointers: Array,
  },
  computed: {
    subdomain() {
      return this.cname.value.split('.').slice(0, -2).join('.')
    },
    domain() {
      return this.cname.value.split('.').slice(-2).join('.')
    },
    cname() {
      return this.pointers.find(({ type }) => type === 'CNAME')
    },
    a() {
      return this.pointers.find(({ type }) => type === 'A')
    },
  },
}
</script>

<template>
  <div>
    <p>{{ $t('projectDomainSetup') }}</p>

    <table class="table--border table--padding">
      <thead>
        <th>{{ $tc('type', 1) }}</th>
        <th>{{ $t('name') }}</th>
        <th>{{ $t('value') }}</th>
      </thead>
      <tbody>
        <tr v-for="pointer in pointers" :key="pointer.value">
          <td>{{ pointer.type }}</td>
          <td>{{ pointer.value }}</td>
          <td>{{ pointer.target }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
